import {Component, OnInit} from '@angular/core';
import {ProfileService} from '../../../../services/profile.service';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {DashBlockComponent} from "../dash-block.component";
import {RouterLink} from "@angular/router";


@Component({
    selector: 'app-dash-block-prestations',
    templateUrl: './dash-block-prestations.component.html',
    imports: [
    FaIconComponent,
    DashBlockComponent,
    RouterLink
],
    styleUrls: ['./dash-block-prestations.component.css']
})
export class DashBlockPrestationsComponent implements OnInit {

  remaining = 5;
  prestations;

  constructor(private profileService: ProfileService) {
  }

  ngOnInit(): void {
    this.profileService.getProfile().subscribe(profile => {
      if (profile.meetings) {
        this.prestations = profile.meetings.filter(m => {
          return m.status === 'Planned';
        });
      }
    });
  }

}
